(function (window, document) {
    console.log('ipRequest.js loading');
    var ipData = null;
    var isTimeoutFinished = false;
    var timeoutTime = 0;
    var useStatus = false;

    function parseHash(hash) {
        hash = hash.slice(1);
        var result = hash.split('&').reduce(function (res, item) {
            var parts = item.split('=');
            var parameterName = parts.slice(0, 1);
            res[parameterName] = (parts.slice(1).join('='));
            return res;
        }, {});

        console.log(result);
        return result;
    }

    function isURIEncoded(parameter) {
        return (parameter.search(/[\/\#\\\+\=]/g) < 0);
    }

    document.addEventListener('DOMContentLoaded', function (event) {
        try {
            var hashParams = parseHash(window.location.hash);
            var getParams = hashParams['ip'] ? '?ip=' + hashParams['ip'] : '';
            if (window.location.hash.substring(1, 6) === 'data=') {
                getParams = (getParams ? '&' : '?') + 'data=' + (isURIEncoded(hashParams['data']) ? hashParams['data'] : encodeURIComponent(hashParams['data']));
                var yiai = getElement('.js-yiai');
                if (yiai) {
                    yiai.classList.add('hide');
                }
                useStatus = true;
            }

            timeoutTime = 0;//Math.floor((Math.random() * 1000) + 1000);

            getIpData(getParams, fillIpData);

            setTimeout(function () {
                isTimeoutFinished = true;
                fillIpData();
            }, timeoutTime);
        } catch (e) {
            console.error(e);
        }
    });

    function getIpData(getParams, callback) {
        var xhr = new XMLHttpRequest();

        xhr.open('GET', location.origin + '/api-ip-status' + getParams);

        xhr.onload = function (e) {

            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    ipData = JSON.parse(xhr.response);
                    ipData.region = ipData.region ? ipData.region : ipData.time_zone;
                } else {
                    ipData = {
                        status: '',
                        ip: '00.000.000.00',
                        country: '',
                        city: '',
                        region: '',
                        timezone: ''
                    };
                    // ipData = {
                    //     "ip": "2a10:8012:21:11f7:2f2:7a86:af48:6525",
                    //     "country": "Localhost",
                    //     "city": "Localhost city",
                    //     "region": "Localhost region",
                    //     "latitude": 0,
                    //     "longitude": 0,
                    //     "timezone": "",
                    //     "inter": false,
                    //     "ipCodeMismatch": false,
                    //     "status": "\u003cdiv class=\"status_info--animation\"\u003e\u003cspan class=\"status_info\"\u003eYOU ARE \u003c/span\u003e\u003cspan class=\"status_info status_info--discon\"\u003eDISCONNECTED\u003c/span\u003e\u003c/div\u003e"
                    // };
                }
                callback();
            }
        };
        xhr.send();
    }

    function fillIpData() {
        if (isTimeoutFinished && ipData) {
            // var loadBar = getElement('.js-load-bar');
            if (window.ipInfoLoaded) {
                try {
                    window.ipInfoLoaded(ipData)
                } catch (e) {
                    console.log(e);
                }
            }

            var ip = getElement('.js-ip');
            var country = getElement('.js-country_name');
            var city = getElement('.js-city_name');
            var region = getElement('.js-region_name');
            var time = getElement('.js-time');

            getConcealedData('ga', true, ipData);
            if (useStatus) {
                if (getElement('.js-status')) {
                    getElement('.js-status').innerHTML = ipData.status;
                }
            }
            if (getElement('.js-status-travel')) {
                var status = getElement('.js-status-travel');
                if (ipData.inter) {
                    status.innerHTML = 'You are connected!';
                } else {
                    status.innerHTML = 'You are disconnected!';
                }
            }

            ip.innerHTML = ipData.ip;
            country.innerHTML = ipData.country;
            city.innerHTML = ipData.city;
            if (region) {
                region.innerHTML = ipData.region;
            }

            isTimeoutFinished = true;

            // loadBar.classList.add('hide');

            ip.classList.add('animated');
            country && country.classList.remove('hide');
            city && city.classList.remove('hide');
            region && region.classList.remove('hide');
            //time && time.classList.remove('hide');
            // if (wow) {
            //     console.log('call wow');
            //     wow.scrolled = true;
            //     wow.scrollCallback();
            // }
            console.log(ipData.ip, ipData.ip.length, "===>")
            if (ipData.ip.length > 14 && window.screen.width < 820) {
                ip.classList.add('resize-ip');
                var dnsHeader = document.querySelector(".js-dns-header");
                if (dnsHeader) {
                    dnsHeader.style.flexDirection = "column";
                    dnsHeader.style.alignItems = "center";
                }
            }
        }
    }

    function getElement(selector) {
        return document.querySelector(selector);
    }

    console.log('ipRequest.js loaded');
})(window, document);